<template>
  <div class="c-flex-c1 background">

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <v-container pa-0 pb-4 style="position: relative;">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

          <c-breadcrumbs :breadcrumbs="[{name: 'Customers', to: '/customers/'}, {name: editMode? editID : 'new', disabled: true}]"></c-breadcrumbs>

          <v-layout align-center>
            <div class="headline font-weight-medium">
              {{ editMode ? 'Edit' : 'Create' }} Customer
            </div>
            <v-spacer></v-spacer>
            <v-slide-x-transition
            mode="out-in">
              <v-btn
              v-if="isDirty"
              text
              rounded
              key="save2"
              :loading="saving"
              @click="validateForm">
                <v-icon color="green accent-4">save_alt</v-icon>
                <div class="ml-1 text--text">
                Save
                </div>
              </v-btn>
              <v-btn
              v-else
              key="save1"
              text
              class="caption"
              disabled>
                Saved
              </v-btn>
            </v-slide-x-transition>
          </v-layout>
          
        </div>

        <!-- MOBILE toolbar -->
        <div v-if="$vuetify.breakpoint.xs" class="toolbar-mobile">
          <v-layout align-center>
            <v-btn icon @click="drawer = !drawer">
              <v-icon>menu</v-icon>
            </v-btn>
            <v-flex class="text-ellipsed text-sans font-weight-bold">
              Customer
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div style="overflow: auto; flex: 1;">

      <v-container pa-0 pb-4>
      
        <t-item-diff v-if="$store.state.settings.debugMode" :item1="lastSave" :item2="merged">
          <v-layout 
          slot="item1Header"
          align-center class="subheading font-weight-bold pl-2 crx-toolbar">
            Last save
          </v-layout>
          <v-layout 
          slot="item2Header"
          align-center class="subheading font-weight-bold pl-2 crx-toolbar">
            LIVE
          </v-layout>
        </t-item-diff>
        
        <v-row>
          <v-col md="6">
            <v-card>
              <v-layout align-center class="headline font-weight-bold pl-2 crx-toolbar">
                Customer
              </v-layout>

              <v-row class="align-center">
                <v-col md="3">
                  <div class="label">Name:</div>
                </v-col>
                <v-col md="9">
                  <c-input :value.sync="customer.name" class="crx-box-input"></c-input>
                </v-col>
              </v-row>

              <v-radio-group v-model="customer.type" row class="ml-4">
                <v-radio label="Person" :value="0" color="primary"></v-radio>
                <v-radio label="Business" :value="1" color="primary"></v-radio>
              </v-radio-group>

              <v-row class="align-center">
                <v-col md="3">
                  <div class="label">Phone:</div>
                </v-col>
                <v-col md="9">
                  <c-input :value.sync="customer.phone" class="crx-box-input"></c-input>
                </v-col>
              </v-row>

              <v-row class="align-center">
                <v-col md="3">
                  <div class="label">Email:</div>
                </v-col>
                <v-col md="9">
                  <c-input :value.sync="customer.email" class="crx-box-input"></c-input>
                </v-col>
              </v-row>

              <v-row class="align-center">
                <v-col md="3">
                  <div class="label">Vat number:</div>
                </v-col>
                <v-col md="9">
                  <c-input :value.sync="customer.vat_number" :disabled="customer.type === 0" class="crx-box-input"></c-input>
                </v-col>
              </v-row>
              
            </v-card>
          </v-col>
          <v-col md="6">
            <v-card>
              <v-layout class="pa-4 headline font-weight-bold">
                Document block
              </v-layout>
              <div class="c-hr"></div>

              <div class="pa-2 text--text text--darken-1">
                This is how you want this customer to appear on official documents such as invoices
              </div>

              <div class="c-hr"></div>

              <div class="pa-4">
                <v-textarea 
                v-model="customer.document_block" 
                class="crx-box-input"
                counter="300"
                hide-details
                >
                </v-textarea>
              </div>

            </v-card>
          </v-col>
        </v-row>


        <!-- MOST LIKELY DEPRECATED -->
        <c-expansion-panel>
          <template v-slot:header="{ expand }">
            <div>
              <v-row class="pa-3 justify-center align-cneter unselectable">
                <v-icon color="textSecondary">mdi-tune</v-icon>
                &nbsp;
                <div class="font-weight-medium textSecondary--text">
                  DEPRECATED
                </div>
              </v-row>
            </div>
          </template>
          <template v-slot:body>
            <v-layout wrap class="mt-4">

              <v-flex xs12 sm6 pa-2>

                <v-card>
                  <v-layout align-center class="headline font-weight-bold pl-2 crx-toolbar">
                    Invoice Address
                  </v-layout>

                  <div class="pa-4">
                    <address-form :formData="invoiceAddress"></address-form>
                  </div>

                </v-card>
              </v-flex>

              <v-flex xs12 sm6 pa-2>

                <v-card>
                  <v-layout align-center class="headline font-weight-bold pl-2 crx-toolbar">
                    Delivery Address
                  </v-layout>

                  <div class="pa-4">
                    <address-form :formData="deliveryAddress"></address-form>
                  </div>

                </v-card>

              </v-flex>

            </v-layout>
          </template>
        </c-expansion-panel>

      </v-container>

    </div>
    <!-- END MAIN CONTENT -->

  </div>
</template>

<script>
import axios from 'axios'
import Address from '@/components/v/addresses/Address'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  components: {
    'address-form': Address
  },
  mixins: [validationMixin],
  data () {
    return {
      saving: false,
      editMode: false,
      editID: null,
      lastSave: {
        customer: {
          type: 0,
          name: '',
          phone: '',
          email: '',
          vat_number: '',
          document_block: ''
        }
      },
      customer: {
        type: 0,
        name: '',
        phone: '',
        email: '',
        vat_number: '',
        document_block: ''
      },
      invoiceAddress: {
        address: '',
        address2: '',
        state: '',
        city: '',
        zip_code: '',
        country: '',
        phone: ''
      },
      deliveryAddress: {
        address: '',
        address2: '',
        state: '',
        city: '',
        zip_code: '',
        country: '',
        phone: ''
      }
    }
  },
  computed: {
    isDirty () {
      return !this.$_.isEqual(this.lastSave, this.merged)
      /* for (var key of Object.keys(this.lastSave)) {
        if (this.merged[key] !== this.lastSave[key]) {
          return true
        }
      }
      return false */
    },
    merged () {
      var merged = {
        customer: JSON.parse(JSON.stringify(this.customer))
      }
      return merged
    },
    nameErrors () {
      const errors = []
      if (!this.$v.customer.name.$dirty) return errors
      !this.$v.customer.name.maxLength && errors.push('Name must be less than 120 characters')
      !this.$v.customer.name.required && errors.push('Name is required.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.customer.email.$dirty) return errors
      !this.$v.customer.email.maxLength && errors.push('Email must be less than 255 characters')
      return errors
    }
  },
  methods: {
    new () {
      this.customer.type = 0
      this.customer.name = ''
      this.customer.phone = ''
      this.customer.email = ''
      this.customer.vat_number = ''
      this.document_block = ''
      Object.keys(this.invoiceAddress).forEach(key => {
        this.invoiceAddress[key] = ''
      })
      Object.keys(this.deliveryAddress).forEach(key => {
        this.deliveryAddress[key] = ''
      })

      this.editMode = false
      this.editID = null
    },
    debounceLoad: _.debounce(function (id) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        axios.all([
          this.$axios.get(`/customers/${id}`)
        ])
        .then(axios.spread((response_customer) => {
          console.log(response_customer)
          var _customer = response_customer.data
          this.customer = {
            type: _customer.type,
            name: _customer.name,
            phone: _customer.phone,
            email: _customer.email,
            vat_number: _customer.vat_number,
            document_block: _customer.document_block
          }

          this.lastSave.customer = JSON.parse(JSON.stringify(this.customer))

        }))
        .then(() => resolve())
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }, 150, {leading: true}),
    edit (id) {
      this.editID = id
      this.editMode = true
      /* var customer = this.$store.state.db.customers.customers[id]
      this.customer = {
        type: customer.type,
        name: customer.name,
        phone: customer.phone,
        email: customer.email,
        vat_number: customer.vat_number,
        document_block: customer.document_block
      } */
      this.debounceLoad(id)
      /* var invoiceAddress = this.$store.state.db.addresses.addresses[this.customer.invoice_addr]
      this.invoiceAddress = Object.assign({}, invoiceAddress)
      var deliveryAddress = this.$store.state.db.addresses.addresses[this.customer.delivery_addr]
      this.deliveryAddress = Object.assign({}, deliveryAddress)
      */
      // setup last save
      // this.lastSave.invoiceAddress = JSON.stringify(this.invoiceAddress)
      // this.lastSave.deliveryAddress = JSON.stringify(this.deliveryAddress)
    },
    validateForm () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        // fix form errors
      } else {
        this.editMode ? this.updateItem() : this.createItem()
      }
    },
    createItem () {
      this.saving = true
      this.error = ''

      var data = {
        customer: this.customer
        // invoiceAddress: this.invoiceAddress,
        // deliveryAddress: this.deliveryAddress
      }
      this.$axios.post('customers/create',
        data,
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.$router.push('/customers')
          })
        .catch(
          (error) => {
            console.log(error.response.data)
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.saving = false
        })
        // */
    },
    updateItem () {
      this.saving = true
      this.error = ''

      var data = {
        editID: this.editID,
        customer: this.customer,
        // invoiceAddress: this.invoiceAddress,
        // deliveryAddress: this.deliveryAddress
      }
      this.$axios.post('customers/update',
        data,
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.lastSave.customer = JSON.parse(JSON.stringify(data.customer))
            // this.lastSave.invoiceAddress = JSON.stringify(data.invoiceAddress)
            // this.lastSave.deliveryAddress = JSON.stringify(data.deliveryAddress)
          })
        .catch(
          (error) => {
            console.log(error.response.data)
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.saving = false
        })
        // */
    }
  },
  validations: {
    customer: {
      name: { required, maxLength: maxLength(120) },
      email: { maxLength: maxLength(255) }
    }
  },
  mounted () {
    /* this.$nextTick(() => {
      this.lastSave.customer = Object.assign({}, this.customer)
      this.lastSave.invoiceAddress = Object.assign({}, this.invoiceAddress)
      this.lastSave.deliveryAddress = Object.assign({}, this.deliveryAddress)
    }) */
  }
}
</script>
